import {
    TableBody,
    Grid,
    Table,
    TableCell,
    TableFooter,
    TableHead,
    TableRow,
    TextField,
    Tooltip
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React, { useCallback } from 'react';
import IconButton from '@material-ui/core/IconButton';
import GuestField from './GuestField';
import FormSection from '../../../../components/atom/FormSection';
import { PlusIcon } from '../../../../icons';

const generateHashChars = len => Math.floor(Math.random() * 16 ** len).toString(16);

const GuestFieldTable = ({
    guestFields,
    setGuestFields,
    headerFields,
    setHeaderFields,
    headerFieldsOptions,
    setErrors,
    errors
}) => {
    const setGuestField = useCallback(
        field => setGuestFields(guestFields.map(f => (f.id === field.id ? field : f))),
        [setGuestFields, guestFields]
    );

    const removeGuestField = useCallback(
        field => setGuestFields(guestFields.filter(f => f.id !== field.id)),
        [setGuestFields, guestFields]
    );

    return (
        <FormSection title="Guest fields">
            <Table style={{ backgroundColor: 'white' }} size="small">
                <TableHead>
                    <TableRow>
                        <TableCell style={{ width: 40 }} />
                        <TableCell>Name</TableCell>
                        <TableCell>Type</TableCell>
                        <TableCell>Agent only</TableCell>
                        <TableCell>Required</TableCell>
                        <TableCell>Available during registration</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {guestFields.map(guestField => (
                        <GuestField
                            key={guestField.id}
                            guestField={guestField}
                            setGuestField={setGuestField}
                            removeGuestField={removeGuestField}
                            setErrors={setErrors}
                            errors={errors}
                        />
                    ))}
                </TableBody>
                <TableFooter>
                    <TableRow>
                        <TableCell colSpan={7}>
                            <IconButton
                                disabled={!guestFields.every(({ name }) => name)}
                                onClick={() =>
                                    setGuestFields(
                                        guestFields.concat([
                                            {
                                                id: generateHashChars(12),
                                                type: 'string',
                                                name: ''
                                            }
                                        ])
                                    )
                                }
                            >
                                <Tooltip title="Add new guest field">
                                    <PlusIcon color="disabled" />
                                </Tooltip>
                            </IconButton>
                        </TableCell>
                    </TableRow>
                </TableFooter>
            </Table>
            <Grid item />
            <Grid item xs={12}>
                <Autocomplete
                    multiple
                    options={headerFieldsOptions}
                    value={headerFields}
                    getOptionLabel={option => option.name}
                    filterSelectedOptions
                    getOptionSelected={(option, value) => option.value === value.value}
                    onChange={(_, newValue) => setHeaderFields(newValue)}
                    renderInput={params => (
                        <TextField
                            {...params}
                            variant="standard"
                            label="Fields shown in the header"
                            placeholder="Fields will appear in header in the same order as in the list under"
                            fullWidth
                        />
                    )}
                />
            </Grid>
        </FormSection>
    );
};

export default GuestFieldTable;
